import * as React from 'react';
import * as Tools from "../../helpers/Tools";
import { queryParams } from "../../helpers/formatting";
import { getDirectionsUrl } from "../../helpers/location";
import { connect } from "react-redux";
import { logUI } from "../../api/andyliticsApi";
import { Link } from "react-router-dom";

const DATE_FORMAT = Tools.getDateFormats();

class VisitTypeInfo extends React.Component {
  
    constructor(props) {
        super(props);
        this.state = {
            isVisitTypePreSelected : false,
            validationError: "",
            selectedVisitType: {
                label: '',
                value: '',
                startDate: ''
            }
        };
        this.onVisitTypeSelected = this.onVisitTypeSelected.bind(this);
        this.mounted = false;
    }
   
    componentDidMount() {
        logUI("MBHWeb.UI.VisitTypeInfo.ComponentDidMount", new Date(), Tools.getURLPath());
        this.mounted = true;
        const { serverData } = this.props;
        const enableV3SearchForAllProviders = serverData && serverData.enableV3SearchForAllProviders;
        if (!enableV3SearchForAllProviders) {
            this.setState({
                isVisitTypePreSelected: true
            });
        }
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    seeAllSearchResult = () => {
        //back to FC search
    }

    seeAllLocations = () => {
        // move to location screen
    }
    

    onVisitTypeSelected(visitType) {
        this.setState({
            isVisitTypePreSelected : true,
            showAsInvalid: false,
            selectedVisitType: {
                label: visitType.label,
                value: visitType.value,
                startDate: visitType.startDate
            }
        });
    }

    isValid() {
        return this.isValidate();
    }

    onGoNext(success) {
        if (!success) {
            this.setState({ showAsInvalid: true });
        }
        const { visit, departments, routeTime } = this.props;
        let todayDate = new Date();
        let routeDate = this.props.routeDate ? this.props.routeDate : `${todayDate.getFullYear()}-${todayDate.getMonth() + 1}-${todayDate.getDate()}`
        const { selectedVisitType } = this.state;
        if (selectedVisitType && visit && ((selectedVisitType.label && selectedVisitType.value && selectedVisitType.label !== visit.visitType.description) ||
            (selectedVisitType.label === '' && selectedVisitType.value === '' && visit.visitType.id))) {
            const isSelectedVisitTypeEmpty = (selectedVisitType.label === '' && selectedVisitType.value === '' && visit.visitType.id) ? true : false;
            if (isSelectedVisitTypeEmpty) {
                this.setState({
                    selectedVisitType: {
                        label: visit.visitType.description,
                        value: visit.visitType.id + '|' + visit.visitType.idType
                    }
                });
            } else {
                const id = selectedVisitType.value ? selectedVisitType.value.split("|")[0] : '';
                const type = selectedVisitType.value ? selectedVisitType.value.split("|")[1] : '';
                const visitTypeStartDate =  selectedVisitType && selectedVisitType.startDate && Tools.toJSDate(`${selectedVisitType.startDate} 00:00:00`, DATE_FORMAT);
                const visitTypeEndOfMonth =  visitTypeStartDate && Tools.getEndOfMonth(visitTypeStartDate.getFullYear(), visitTypeStartDate.getMonth());
                const visitTypeEndDate =  visitTypeEndOfMonth && `${visitTypeEndOfMonth.getFullYear()}-${visitTypeEndOfMonth.getMonth() + 1}-${visitTypeEndOfMonth.getDate()}`;
                if (id && type) {
                    visit.visitType.id = id;
                    visit.visitType.description = selectedVisitType ? selectedVisitType.label : "";
                    visit.visitType.idType = type;
                    visit.visitType.startDate = selectedVisitType && selectedVisitType.startDate && selectedVisitType.startDate;
                    visit.visitType.endDate = visitTypeEndDate;
                }
            }
            const loadScheduleDays = departments && departments.length === 1;
            let startDate = Tools.toJSDate(`${routeDate} 00:00:00`, DATE_FORMAT);
            let dtEnd = Tools.getEndOfMonth(startDate.getFullYear(), startDate.getMonth());
            let endDate = `${dtEnd.getFullYear()}-${dtEnd.getMonth() + 1}-${dtEnd.getDate()}`
            visit.date = this.props.routeDate ? this.props.routeDate : '';
            visit.time = routeTime ? routeTime : "";
            if (!isSelectedVisitTypeEmpty && selectedVisitType.value) {
                this.props.saveStepInfo({ visitTypeChanged: true, visit: visit, startDate: routeDate, endDate }, loadScheduleDays);
            } else {
                this.props.saveStepInfo({ visit: visit, startDate: routeDate, endDate }, loadScheduleDays);
            }
            logUI("MBHWeb.UI.VisitTypeInfo.Continue.Clicked", new Date(), Tools.getURLPath(), { visit: visit, startDate: routeDate, endDate });
        } else {
            logUI("MBHWeb.UI.VisitTypeInfo.Continue.Clicked", new Date(), Tools.getURLPath(), { visit: visit });
        }
    }

    isValidate() {
        const { isVisitTypePreSelected } = this.state;
        if (!isVisitTypePreSelected) {
            this.setState({ validationError: "Please select a visit type." });
            return false;
        }
        return true;
    }

    redirectToMap(item) {
        if (item.Address) {
            const toAddress = item.Address.locationStreet1 + ', ' + item.Address.locationCity + ', ' + item.Address.locationState + ' ' + item.Address.locationZip;
            var addressUrl = getDirectionsUrl(null, toAddress);
            if (typeof window !== 'undefined' && addressUrl) {
                window.open(addressUrl, "_blank");
            }
        }
    }

    providerCard = () => {
        const { providerDetails, visit, departments, provider, providerSearchModel } = this.props;
       
        const selectedDepartmentId = visit && visit.department && visit.department.id ? visit.department.id : "";
        const address = selectedDepartmentId && departments ? departments.find((item) => item.value.indexOf(selectedDepartmentId) >= 0) : undefined;
        const defaultPhone = providerDetails && providerDetails.consumerCallCenterNumber ? providerDetails.consumerCallCenterNumber : (address && address.phone ? address.phone : "");
        const prov = {
            photo: provider ? provider.photoUrl : '',
            displayName: provider ? provider.displayName : "",
            specialty: provider ? provider.specialty : "",
            Address: {
                locationName: address ? address.label : "",
                locationStreet1: address ? address.address1 : "",
                locationStreet2: address ? address.address2 : "",
                locationCity: address ? address.city : "",
                locationState: address ? address.state : "",
                locationZip: address ? address.zip : ""
            }
        };
        let changeProviderUrl = '/findcare';
        let findcareSearchParms = "?" + queryParams({
            keyword: providerSearchModel && providerSearchModel.keyword ? providerSearchModel.keyword : null,
            location: providerSearchModel && providerSearchModel.location ? providerSearchModel.location : null
        });
        changeProviderUrl = changeProviderUrl + findcareSearchParms;

        return (
            <div className="card visit_type_docs">
                <div className="visit_type_card-body">
                    <div className="row">
                        <div className="col-12">
                            <Link className="btn text-btn btn-provider" to={changeProviderUrl} onClick={(e) => { logUI("MBHWeb.UI.VisitTypeInfo.ChangeProvider.Clicked", new Date(), Tools.getURLPath()); }}>CHANGE PROVIDER</Link>
                            <div className="visit_type_docs__info">
                                <div className="visit_type_docs__img-container">
                                    <img alt={Tools.trimComma(prov.displayName)} src={prov.photo || "/images/profile-pic.png"} />
                                </div>

                                <div className="row visit_type_docs__info-container">
                                    <div className="col-12">
                                        <div className="visit_type_docs__info-container--name">
                                            {Tools.trimComma(prov.displayName)}
                                        </div>
                                        <div className="visit_type_docs__info-container--specialty">
                                            {prov.specialty}
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="visit_type_docs__info-container--details show-schedule-options">
                                            <a className={"details-icon-prepend" + (prov.Address ? " directions-link" : " no-link")} onClick={() => this.redirectToMap(prov)}>
                                                <div className="icon-col"><span className="icon-address" /></div>
                                                {prov.Address ?
                                                    <div className="details-col">
                                                        <div className="details-col-text">{prov.Address && prov.Address.locationName}</div>
                                                        <div>{prov.Address.locationStreet1 + ", " + prov.Address.locationStreet2 + ", "+ prov.Address.locationCity + ", " + prov.Address.locationState}</div>
                                                    </div> :
                                                    <React.Fragment>
                                                        <div className="details-col">
                                                            <div className="no-data-dash">
                                                                <div />
                                                            </div>
                                                        </div>
                                                    </React.Fragment>
                                                }
                                            </a>
                                            <div className="details-icon-prepend">
                                                {defaultPhone ?
                                                    <a className="phone-link" href={"tel:" + defaultPhone}>
                                                        <div className="icon-col"><span className="icon-phone" /></div>
                                                        <div className="details-col">
                                                            {defaultPhone}
                                                        </div>
                                                    </a>
                                                    : <React.Fragment>
                                                        <div className="icon-col"><span className="icon-phone" /></div>
                                                        <div className="details-col">
                                                            <div className="no-data-dash">
                                                                <div />
                                                            </div>
                                                        </div>
                                                    </React.Fragment>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { visit, visitTypes, provider } = this.props;
        const { selectedVisitType, isVisitTypePreSelected, showAsInvalid, validationError} = this.state;
        const currentVisitName = isVisitTypePreSelected ? selectedVisitType && selectedVisitType.label ? selectedVisitType.label : visit && visit.visitType && visit.visitType.description ? visit.visitType.description : "" :"";

        return (
            (visitTypes && provider) ? <div className = "visit-type-info-container" style = { this.props.style }>
                <div className="row">
                    <div className="col-12 text-center">
                        <div className="select-visit-type-title">
                            <div className="item-img-container">
                                <span className="svg-find-a-doc" />
                            </div>
                            <h1 className="step-head">What are you coming in for?</h1>
                        </div>
                    </div>
                    <div className="col-12 visit-type-sub-container">
                        <>
                            {
                                this.providerCard()
                            }
                        </>
                    </div>
                    <div className="col-12 select-visit-type-list">
                        {visitTypes && visitTypes.length > 0 &&
                            visitTypes.map((visitType, index) =>
                                <div className="form-group" key={index}>
                                    <button className={`btn btn-primary ${currentVisitName && visitType && visitType.label && currentVisitName.toLowerCase() === visitType.label.toLowerCase() ? 'active' : ''}`}
                                        onClick={(event) => this.onVisitTypeSelected(visitType)}>
                                        {visitType && visitType.label ? visitType.label : ""}
                                    </button>
                                </div>
                            )}
                    </div>
                </div>
                {(showAsInvalid && validationError !== "") &&
                    <div className="text-center validation-error-container">
                      <div className="error-msg">{validationError}</div>
                    </div>
                }
            </div> : <></>
        )
    }
};

const mapStateToProps = (state) => {
    return {
        providerSearchModel: state.providers.searchModel
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(VisitTypeInfo);